export default __webpack_public_path__ + "static/atencion_personalizada-22ca6dcd2e490cd906e9dd982d514c30.png";